import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { Link } from 'react-router-dom';

const Completed: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('Finish must be used within an AppProvider');
  }

  const { appData } = context;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  

  return (
    <div className="content" style={{ minHeight: 'auto' }}>
      <div className="mx-auto max-w-2xl text-center py-12">
        <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          Processo concluído com sucesso! 🎉
        </p>
        <p className="mt-6 text-lg text-gray-700">
          Suas informações foram enviadas com sucesso para a equipe de desenvolvimento.
          A personalização do seu app já está em andamento.
        </p>
        <div className="mt-6 p-6 border border-gray-200 rounded-xl bg-gray-50">
          <p className="font-semibold text-lg">O que acontece agora:</p>
          <ul className="mt-3 list-disc list-inside text-gray-700 text-left">
            <li>Nosso time irá revisar os dados enviados.</li>
            <li>Você poderá ser contatado caso alguma informação precise ser ajustada.</li>
            <li>O app será configurado conforme as preferências que você definiu.</li>
            <li>Você receberá um link para visualizar uma prévia ou o app finalizado.</li>
          </ul>
        </div>
        <p className="mt-6 text-gray-600">
          Se você tiver dúvidas ou quiser entrar em contato com nosso suporte.
        </p>
        <p className="mt-4 text-gray-800">
          Obrigado por personalizar o app com a gente!
        </p>
      </div>
    </div>
  );
};

export default Completed;
